<ng-container>
  <h2 mat-dialog-title>Debug &#64; {{whereImAt}}</h2>

  @if (!signalRService.chatActive) {
  <button mat-stroked-button (click)="signalRService.showChat()">Show chat</button>
  }
  @if (signalRService.chatActive) {
  <button mat-stroked-button (click)="signalRService.hideChat()">Hide chat</button>
  }

  <mat-dialog-content>
    <mat-accordion class="example-headers-align">
      <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)" hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            User data
          </mat-panel-title>
          @if (authService.loggedIn()) {
          <mat-panel-description>
            Logged in as: {{authService.username}}
            <mat-icon>account_circle</mat-icon>
          </mat-panel-description>
          }

          @if (!authService.loggedIn()) {
          <mat-panel-description>
            Not logged in
            <mat-icon>account_circle</mat-icon>
          </mat-panel-description>
          }
        </mat-expansion-panel-header>
        <div>LocalStorage {{localStorageUsage}}</div>
        @if (authService.loggedIn()) {
        <div>{{'AUTH.USER_WILL_BE_LOGGED_OUT' | transloco}} {{tokenExpires}}</div>
        }
        @if (authService.loggedIn()) {
        <div>
          {{'AUTH.USER_WILL_BE_LOGGED_OUT_DUE_TO_INACTIVITY_AT' | transloco}} : {{authService.getTokenExpirationDate()}}
        </div>
        }

        @if (userTimedOutUserName) {
        <div>Show login for: {{userTimedOutUserName}}</div>
        }
        @if (userAboutToGetTimedOut) {
        <div>{{'AUTH.USER_ABOUT_TO_GET_TIMED_OUT' | transloco}}</div>
        }

        <button mat-stroked-button
          (click)="refreshMyConfig()">refreshMyConfig({{myConfigService?.myConfig?.organizations?.length}})</button>
        <button mat-stroked-button (click)="refreshToken()">refreshToken()</button>
        <button mat-stroked-button (click)="authService.forceTimeOut()">forceTimeOut()</button>
        <button mat-stroked-button (click)="authService.forceTimeOutWarning()">forceTimeOutWarning()</button>
        <div class="mt-2">
          <mat-slide-toggle [(ngModel)]="isChecked" (change)="toggle($event)">Show travelAgency
          </mat-slide-toggle>
        </div>
        <mat-action-row>
          <button mat-button color="primary" (click)="nextStep()">Next</button>
        </mat-action-row>
      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)" hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            CJHub
          </mat-panel-title>
          <mat-panel-description>
            State: {{cjHubService.getConnectionState()}}
            @if (cjHubService.connectionDetails) {
            <span>{{cjHubService.connectionDetails.machineName}}</span>
            }
            @if (cjHubService.connectionDetails) {
            <span>{{cjHubService.connectionDetails.clientIpAddress}}</span>
            }
            <mat-icon>map</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <button mat-stroked-button (click)="cjHubService.startConnection()">startConnection()</button>
        <button mat-stroked-button (click)="cjHubService.stopConnection()">stopConnection()</button>
        <button mat-stroked-button (click)="sendMessage()">sendMessage()</button>
        @if (!cjHubService.cjHubDebugToConsole) {
        <button mat-stroked-button (click)="cjHubService.showConsoleDebug()">Show console debug</button>
        }
        @if (cjHubService.cjHubDebugToConsole) {
        <button mat-stroked-button (click)="cjHubService.hideConsoleDebug()">Hide console debug</button>
        }
        @if (cjHubService.connectionDetails) {
        <div>MachineName: {{cjHubService.connectionDetails.machineName}}</div>
        }
        @if (cjHubService.connectionDetails) {
        <div>ClientIpAddress: {{cjHubService.connectionDetails.clientIpAddress}}
        </div>
        }
        @if (cjHubService.connectionDetails) {
        <div>UserId: {{cjHubService.connectionDetails.userId}}</div>
        }
        @if (cjHubService.connectionDetails) {
        <div>DisplayName: {{JSON.stringify(cjHubService.connectionDetails.displayName)}}</div>
        }
        @if (cjHubService.connectionDetails) {
        <div>Site: {{JSON.stringify(cjHubService.connectionDetails.site)}}</div>
        }
        @if (cjHubService.connectionDetails) {
        <div>SiteUser:
          {{JSON.stringify(cjHubService.connectionDetails.siteUser)}}</div>
        }
        @if (cjHubService.connectionDetails) {
        <div>Roles: {{JSON.stringify(cjHubService.connectionDetails.roles)}}
        </div>
        }
        @if (cjHubService.connectionDetails) {
        <div>Groups: {{JSON.stringify(cjHubService.connectionDetails.groups)}}
        </div>
        }
        @if (cjHubService.connectionDetails) {
        <div>Created: {{JSON.stringify(cjHubService.connectionDetails.created)}}
        </div>
        }


        <ul class="debug-log-list">
          @for (item of cjHubService.myLogger.hubConnectionLog; track item; let i = $index) {
          <li>
            @if (cjHubService.myLogger.hubConnectionLog[cjHubService.myLogger.hubConnectionLog.length-i-1]; as logEntry)
            {
            {{logEntry}}
            }
          </li>
          }
        </ul>

        <mat-action-row>
          <button mat-button color="warn" (click)="prevStep()">Previous</button>
          <button mat-button color="primary" (click)="nextStep()">Next</button>
        </mat-action-row>
      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)" hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Extras
          </mat-panel-title>
          <mat-panel-description>
            Useful links
            <mat-icon>more_vert</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <button mat-stroked-button (click)="goToDashboard()">goToDashboard()</button>

        <mat-action-row>
          <button mat-button color="warn" (click)="prevStep()">Previous</button>
          <button mat-button color="primary" (click)="nextStep()">End</button>
        </mat-action-row>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-dialog-content>

</ng-container>

<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Close</button>
</mat-dialog-actions>